import {Component, inject, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../services/auth.service";
import {NotificationService} from "../../services/notification.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-set-password',
    templateUrl: './set-password.component.html',
    styleUrls: ['./set-password.component.scss'],
    standalone: false
})
export class SetPasswordComponent implements OnInit {
  private fb: FormBuilder = inject(FormBuilder)
  private authService: AuthService = inject(AuthService)
  private notificationService: NotificationService = inject(NotificationService);
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);

  form: FormGroup;

  loading = false;

  // password
  showPassword: boolean = true;
  showPassword2: boolean = true;

  token: string;


  constructor() {
  }

  ngOnInit() {
    this.token = this.activatedRoute.snapshot.paramMap.get("token")
    
    this.form = this.fb.group({
      password: [null, Validators.required],
      confirmPassword: [null, Validators.required],
    });
  }

  submitForm(value){
    if(value.password === value.confirmPassword){
      let data = {
        userPassword: value.password,
        requestToken: this.token
      }
      this.authService.setPassword(data).then(
        async (response) => {
          if (response.status) {
            await this.router.navigate(['', 'login']);
          }
        }
      )
    }
    else{
      this.notificationService.errorMessage("Passwords do not match");
    }
  }
}
